export enum ApplicationStatusReason_Enum {
  SeeLog = 113,
  Duplicate = 125,
  DeclinedBadCredit = 129,
  NoContact = 135,
  DeclinedWeakCredit = 150,
  SuspectedFraud = 153,
  IncorrectContactDetails = 154,
  WantsACar = 155,
  DoesNotWantACar = 156,
  ConfirmNoChange = 157,
  UpdateInfo = 158,
  AmigoOption = 159,
  VehicleOutsideLenderReq = 160,
  CustomerOutsideLenderReq = 161,
  NTUCostTooHigh = 165,
  NTUGoneToCompetitor = 166,
  NTUStraightToDealer = 167,
  NTUPausedSearch = 168,
  OpenBanking = 169,
  DeclinedOpenBanking = 170
}
